import Vue from 'vue';
import { SvgIcon } from '@hb/gggj_lib'; // svg component

// register globally
Vue.component('SvgIcon', SvgIcon);

const req = require.context('./svg', false, /\.svg$/);
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
requireAll(req);
